import React, { useState, useRef } from "react";
import {
  X,
  SendHorizontal,
  Image as ImageIcon,
  Bell,
  Link,
  Upload,
  Trash2,
} from "lucide-react";

const NotificationPopup = ({ onClose, onSubmit, isLoading }) => {
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    icon: "/uploads/2024/10/06/logo_a.png",
    url: "#",
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [error, setError] = useState(""); // State for validation error
  const fileInputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate icon field
    if (!selectedImage && !formData.icon) {
      setError("يجب اختيار أيقونة أو إدخال رابط للأيقونة");
      return;
    }
    setError(""); // Clear error if validation passes

    // Create FormData for file upload
    const submitData = new FormData();
    submitData.append("title", formData.title);
    submitData.append("message", formData.message);
    submitData.append("url", formData.url);
    if (selectedImage) {
      submitData.append("icon", selectedImage);
    } else {
      submitData.append("icon", formData.icon);
    }
    onSubmit(submitData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert("حجم الصورة يجب أن يكون أقل من 5 ميغابايت");
        return;
      }

      if (!file.type.startsWith("image/")) {
        alert("يرجى اختيار ملف صورة صالح");
        return;
      }

      setSelectedImage(file);
      setPreviewUrl(URL.createObjectURL(file));
      setFormData((prev) => ({ ...prev, icon: "" }));
    }
  };

  const removeImage = () => {
    setSelectedImage(null);
    setPreviewUrl("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-xl flex items-center justify-center z-[9000]">
      <div className="bg-gray-900 rounded-xl shadow-xl w-full max-w-md transform transition-all duration-300 scale-100 opacity-100 ">
        <div className="flex items-center justify-between p-6 border-b border-gray-800">
          <div className="flex items-center gap-3">
            <div className="bg-yellow-500/10 p-2 rounded-lg">
              <Bell className="h-5 w-5 text-yellow-500" />
            </div>
            <h2 className="text-xl font-semibold text-white">إرسال إشعار</h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-800 rounded-full transition-colors"
          >
            <X className="h-5 w-5 text-gray-400 hover:text-white" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4" dir="rtl">
          {/* <div className="space-y-2">
            <div
              onClick={handleImageClick}
              className={`relative w-full h-32 border-2 border-dashed rounded-lg 
                ${previewUrl ? "border-yellow-500/50" : "border-gray-700"} 
                hover:border-yellow-500 transition-colors cursor-pointer group`}
            >
              {previewUrl ? (
                <>
                  <img
                    src={previewUrl}
                    alt="Preview"
                    className="w-full h-full object-contain rounded-lg"
                  />
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeImage();
                    }}
                    className="absolute top-2 right-2 p-1 bg-red-500/80 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <Trash2 className="w-4 h-4 text-white" />
                  </button>
                </>
              ) : (
                <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-400">
                  <Upload className="w-8 h-8 mb-2" />
                  <span className="text-sm">اضغط لاختيار صورة</span>
                  <span className="text-xs text-gray-500 mt-1">
                    PNG, JPG, GIF حتى 5MB
                  </span>
                </div>
              )}
            </div>

            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="hidden"
            />

            <div className="relative mt-2">
              <input
              required
                type="text"
                name="icon"
                value={formData.icon}
                onChange={handleChange}
                disabled={!!selectedImage}
                placeholder="أو أدخل رابط الأيقونة"
                className="w-full bg-gray-800 text-white pl-4 pr-4 py-2.5 rounded-lg border border-gray-700 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 transition-colors placeholder-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
              />
              <ImageIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            </div>
          </div>
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>} */}

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-400">
              عنوان الإشعار
            </label>
            <input
              required
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="أدخل العنوان هنا"
              className="w-full bg-gray-800 text-white pl-4 pr-4 py-2.5 rounded-lg border border-gray-700 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 transition-colors placeholder-gray-500"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-400">
              رسالة الإشعار
            </label>
            <textarea
              required
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="أدخل الرسالة هنا"
              className="w-full bg-gray-800 text-white pl-4 pr-4 py-2.5 rounded-lg border border-gray-700 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 transition-colors placeholder-gray-500 resize-none"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-400">
              رابط URL
            </label>
            <div className="relative">
              <input
                required
                type="text"
                name="url"
                value={formData.url}
                onChange={handleChange}
                placeholder="أدخل الرابط هنا (اختياري)"
                className="w-full bg-gray-800 text-white pl-4 pr-4 py-2.5 rounded-lg border border-gray-700 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 transition-colors placeholder-gray-500"
              />
              <Link className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed mt-6"
          >
            {isLoading ? (
              <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <SendHorizontal className="h-5 w-5" />
                إرسال الإشعار
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NotificationPopup;
